import(/* webpackMode: "eager", webpackExports: ["PageBanner"] */ "/vercel/path0/app/about/components/PageBanner.tsx");
